import {
	ActionListItem,
	DropOverActionList,
	Icon,
	RichTextEditorToolbar
} from "client/Components";
import {
	RichTextEditorToolProps,
	useProseMirrorRichTextEditorTool
} from "client/Components/RichTextEditor/tools/useProseMirrorRichTextEditorTool";
import { isNotNil } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { Command } from "prosemirror-state";
import {
	ReactElement,
	RefObject,
	useCallback,
	useRef,
	useState
} from "react";

export const UserPlaceholderTool = (props: RichTextEditorToolProps): ReactElement => {
	const {
		applyCommand,
		focus
	} = useProseMirrorRichTextEditorTool(props);

	const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
	const buttonRef: RefObject<HTMLButtonElement | null> = useRef<HTMLButtonElement>(null);
	const insertPlaceholderHandler = useCallback(
		(placeholder: string): void => {
			applyCommand(insertPlaceholder(placeholder));
			focus();
		},
		[applyCommand, focus]
	);

	return (
		<>
			<RichTextEditorToolbar.ButtonGroup>
				<RichTextEditorToolbar.Button
					onClick={() => setIsMenuOpen(true)}
					handleOn="click"
					ref={buttonRef}
					tooltip={localize("_AddPlaceholder")}
				>
					<Icon value="address-card" />
				</RichTextEditorToolbar.Button>
			</RichTextEditorToolbar.ButtonGroup>
			{isMenuOpen && isNotNil(buttonRef.current) && (
				<DropOverActionList
					target={buttonRef.current}
					onClose={() => setIsMenuOpen(false)}
					menuTitle={localize("_AddPlaceholder")}
				>
					<ActionListItem
						text={localize("_FirstName")}
						onClick={() => insertPlaceholderHandler("FirstName")}
					/>
					<ActionListItem
						text={localize("_LastName")}
						onClick={() => insertPlaceholderHandler("LastName")}
					/>
					<ActionListItem
						text={localize("_Email")}
						onClick={() => insertPlaceholderHandler("Email")}
					/>
					<ActionListItem
						text={localize("_JobTitle")}
						onClick={() => insertPlaceholderHandler("JobTitle")}
					/>
					<ActionListItem
						text={localize("_PhoneNumber")}
						onClick={() => insertPlaceholderHandler("MobilePhone")}
					/>
				</DropOverActionList>
			)}
		</>
	);
};
UserPlaceholderTool.displayName = "UserPlaceholderTool";

function insertPlaceholder(value: string): Command {
	return (state, dispatch): boolean => {
		if (dispatch) {
			const tr = state.tr;

			tr.insertText(`{{@CurrentUser.${value}}}`);

			tr.scrollIntoView();
			dispatch(tr);
		}

		return true;
	};
}